/*
 * Module for handling the context of a topic
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicContext/topicContextView",
], function (Marionette, Messenger, TopicContextView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicContext";
      this.region = options.region;
    },
    show: function (topic) {
      const contexts = Messenger.reqres.request("kb:contexts");
      this.topic = topic;
      this.view = new TopicContextView.topicContextsView({
        model: this.topic,
        collection: contexts,
      });
      if (!this.topic.readOnly) {
        this.view.on(
          "itemview:select:context",
          function (itemView) {
            //update topic model with the name of the context and the ID
            this.topic.set("contextId", itemView.model.get("id")); //assign new context id to topic (triggers change event on model)
          },
          this,
        );
      }
      this.showRegion(this.view);
    },
  });
});
